<ng-container *ngIf="streamState$ | async as state">
  <aside class="filters-desktop">
    <h2 *ngIf="showFiltersTitle">{{ 'Filtri disponibili' | translate }}</h2>
    <div [class]="displayMode">
      <ng-content></ng-content>
    </div>
  </aside>
</ng-container>
